import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useActivity = (id) => {
  const urlStr = `${getApiUrl()}/activity/${id}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useActivities = () => {
  const urlStr = `${getApiUrl()}/activity`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostActivity = () => {
  const postActivity = async (payload) => {
    try {
      const url = `${getApiUrl()}/admin/activity`;
      const response = await axios.post(url, payload);
      return response;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postActivity;
};

export const usePutActivity = () => {
  const putActivity = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/admin/activity/${id}`;
      const response = await axios.put(url, payload);
      return response;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putActivity;
};
